import React, { useEffect, useState } from 'react';
import style from '../css/OfferImage.module.css';
import { FaAngleLeft, FaAngleRight, FaX } from 'react-icons/fa6';

function OfferImage() {
	const [images, setImages] = useState([]);
	const [error, setError] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(true);

	useEffect(() => {
		const fetchImages = async () => {
			console.log('Fetching images...');
			try {
				const res = await fetch(
					'https://hometech-repairs.in/homeTech/fetchAllImages.php'
				);

				console.log('Response status:', res.status);

				const data = await res.json();
				console.log('Fetched data:', data);

				if (data.status) {
					setImages(data.data);
					console.log('Images set successfully:', data.data);
				} else {
					setError(data.msg || 'Failed to load images');
					console.error('API Error:', data.msg);
				}
			} catch (err) {
				setError('Something went wrong');
				console.error('Fetch error:', err);
			}
		};

		fetchImages();
	}, []);

	return (
		<div>
			{images.length > 0 && isModalOpen == true ? (
				<div
					className={`${style.modal} ${
						isModalOpen ? style.slideIn : style.slideOut
					}`}
				>
					{images.map((img, index) => {
						const imageUrl = 'https://hometech-repairs.in/' + img.image_path;
						console.log(`Rendering image [${index}]:`, imageUrl);
						return (
							<div key={index} className={style.imageCard}>
								<div
									className={style.clsBtn}
									onClick={() => {
										setIsModalOpen(false);
									}}
								>
									<FaAngleRight />
								</div>
								<a href={imageUrl} target="_blank" rel="noopener noreferrer">
									<img
										src={imageUrl}
										alt={`Offer ${index}`}
										className={style.modalImage}
									/>
								</a>
							</div>
						);
					})}
				</div>
			) : (
				<div>
					<div
						className={style.clsBtnOpen}
						onClick={() => {
							setIsModalOpen(true);
						}}
					>
						<FaAngleLeft />
					</div>
				</div>
			)}
		</div>
	);
}

export default OfferImage;
